const AUTH_ROUTES = ['Login', 'Signup', 'Verification']
const AUTH_PATHS = ['/login', '/signup', '/verification']
const AUTH_THEME_COLOR = '#667eea'
const DEFAULT_THEME_COLOR = '#f8fafc'

function applyThemeColor(isAuthRoute) {
  const color = isAuthRoute ? AUTH_THEME_COLOR : DEFAULT_THEME_COLOR

  // Update Android/Chrome theme-color
  const metaThemeColor = document.querySelector('meta[name="theme-color"]')
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', color)
  }

  // Update iOS status bar style for dark/light backgrounds
  const appleStatusBar = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]')
  if (appleStatusBar) {
    appleStatusBar.setAttribute('content', isAuthRoute ? 'black-translucent' : 'default')
  }
}

export function updateThemeColor(routeName) {
  const isAuthRoute = AUTH_ROUTES.includes(routeName)
  applyThemeColor(isAuthRoute)
}

// Initialize theme color based on URL path (runs immediately, before Vue Router resolves)
export function initThemeColor() {
  const path = window.location.pathname.toLowerCase()
  const isAuthPath = AUTH_PATHS.some(authPath => path === authPath || path.startsWith(authPath + '/'))
  applyThemeColor(isAuthPath)
}
